import { convertTimezone } from '@/shared/lib/helpers/convert-timezone.helper';
import { dateFormat } from '@/shared/lib/helpers/date-format.helper';
import { Pagination } from '@/shared/lib/interfaces/pagination.interface';

import { ALARM_DATE_FIELDS } from '../constants/alarm-date-fields.constant';
import { YachtAlarm, YachtAlarmDates, YachtAlarmResponse } from '../types/alarms.interface';
import { getLatestAlarm } from './get-latest-alarm.helper';

export const transformRealTimeDataResponse = (
	response: Pagination<YachtAlarmResponse>,
	timezone: string,
): Pagination<YachtAlarm> => ({
	...response,
	items: response.items.map((item) => {
		const dates: YachtAlarmDates = {
			preWarningAt: item.pre_warning_at,
			preWarningStopAt: item.pre_warning_stop_at,
			firingAt: item.firing_at,
			firingStopAt: item.firing_stop_at,
			ackAt: item.ack_at,
			unackAt: item.unack_at,
		};
		const latestAlarm = getLatestAlarm(dates);
		const startedAt = dates.firingAt ?? dates.preWarningAt;

		return {
			id: item.id,
			yachtId: item.yacht_id,
			name: item.variable_name,
			...dates,
			status: latestAlarm ? ALARM_DATE_FIELDS[latestAlarm.field] : '',
			startedAt: startedAt ? dateFormat(convertTimezone(startedAt, timezone)) : null,
			lastUpdated: latestAlarm ? dateFormat(convertTimezone(latestAlarm.value, timezone)) : null,
			acknowledged: Boolean(dates.ackAt) && !dates.unackAt,
			protocol: item.protocol || null,
			description: item.description || null,
		};
	}),
});
